import arWebsiteSettings from "../../../data/website-settings/ar.json";
import enWebsiteSettings from "../../../data/website-settings/en.json";
import all_flags from "../../../data/feature-flags/all.json";
import useLocalStorage from "@hooks/useLocalStorage";
import useCookieClient from "@hooks/useCookieClient";
import { SHOW_DEBUG_INFO } from "@globalConfig";
export function websiteConfig(lang) {
  if (lang === "ar") {
    return arWebsiteSettings;
  }
  return enWebsiteSettings;
}
export function checkFeatureFlag(flag) {
  var _useLocalStorage = useLocalStorage(false),
    getLocalStorage = _useLocalStorage.getLocalStorage;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  if (__IS_CSR__ && window.location.href.includes(flag)) {
    var urlParams = new URLSearchParams(window.location.search);
    var myParam = urlParams.get(flag);
    return myParam !== "false";
  }
  if (__IS_CSR__ && getLocalStorage(flag)) {
    return Boolean(Number(getLocalStorage(flag))) || getLocalStorage(flag) === "true";
  }
  if (__IS_CSR__ && getCookieClient(flag)) {
    return Boolean(Number(getCookieClient(flag)));
  }
  return all_flags[flag] || false;
}
export function checkTestFlag(flag) {
  var _useLocalStorage2 = useLocalStorage(false),
    getLocalStorage = _useLocalStorage2.getLocalStorage;
  if (!SHOW_DEBUG_INFO) {
    return undefined;
  }
  if (__IS_CSR__ && getLocalStorage(flag)) {
    return getLocalStorage(flag) === "true";
  }
  return undefined;
}
export function checkMobileAppFeatureFlag(flag) {
  var _useLocalStorage3 = useLocalStorage(false),
    getLocalStorage = _useLocalStorage3.getLocalStorage;
  var _useCookieClient2 = useCookieClient(),
    getCookieClient = _useCookieClient2.getCookieClient;
  if (__IS_CSR__ && window.location.href.includes(flag)) {
    var urlParams = new URLSearchParams(window.location.search);
    var myParam = urlParams.get(flag);
    return myParam !== "false";
  }
  if (__IS_CSR__ && getLocalStorage(flag)) {
    return Boolean(Number(getLocalStorage(flag))) || getLocalStorage(flag) === "true";
  }
  if (__IS_CSR__ && getCookieClient(flag)) {
    return Boolean(Number(getCookieClient(flag)));
  }
  return false;
}